module.exports = __webpack_public_path__ + "static/media/user.80a59b5c.png";